module.exports = __webpack_public_path__ + "img/brown_etal_nonlinear_equation.b831beea.png";